import { useEffect, useState } from 'react';
import { Badge, BlockStack, Box, Card, InlineStack, Layout, Link, Text } from '@shopify/polaris';
import { useLookupStore } from '../../../context/useStore';
import { getNiceDate } from '../../../shared/components/events/eventTimeLine';
import { CardHeading } from '../../../shared/components/cards/CardHeading';
import BrandTotalSales from './metrics/BrandTotalSales';
import BrutoProfitGraph from './metrics/BrutoProfit';
import CostDistribution from './metrics/CostDistribution';

const linksForResource = {
  SALE: 'sales',
  INVOICE: 'invoices',
  INVOICE_IN: 'invoices_in',
  PURCHASE: 'purchases',
  CREDIT_NOTE: 'creditnotes',
  CREDIT_NOTE_IN: 'creditnotes_in',
  COMPANY: 'companies',
  COMPANY_CONTACT: 'contacts',
  PRODUCT: 'products',
  INQUIRY: 'inquiries',
  QUOTATION: 'quotations',
  DELIVERY_ORDER: 'delivery_notes',
  INSTALLATION_NOTE: 'montage_bons',
  MAINTENANCE_CONTRACT: 'maintenance_contracts'
};

export default function OverviewTab() {
  const [events, setEvents] = useState([]);
  const users = useLookupStore((state) => state.users);

  useEffect(() => {
    async function fetchEvents() {
      const res = await fetch('/api/events');
      const data = await res.json();
      setEvents(data);
    }
    fetchEvents();
  }, []);

  return (
    <BlockStack gap="400">
      {/* <MetricMonthYearLine type={'invoicing_out'} /> */}
      <BrutoProfitGraph />
      <BrandTotalSales />
      <CostDistribution />
      <Layout>
        <Layout.Section variant="oneHalf">
          <Card>
            <CardHeading title="Last 250 events" />
            {Array.isArray(events) &&
              events.map((event, idx) => {
                return (
                  <Box key={'event-' + idx} paddingBlockEnd={'100'}>
                    <InlineStack gap="400">
                      <Text>{event.type === 'CREATE' ? '🎉' : event.type === 'UPDATE' ? '🛠' : event.type === 'DELETE' ? '❌' : event.type === 'EMAIL_SENT' ? '✉️' : '📣'}</Text>
                      <Text>{users.find((user) => user.GebruikerID === event.user_id)?.Afkorting}</Text>
                      <Text>
                        <Badge tone="success">
                          {event.type === 'CREATE' ? 'create' : event.type === 'UPDATE' ? 'update' : event.type === 'DELETE' ? 'delete' : event.type === 'MAIL' ? 'mail sent' : event.type}
                        </Badge>
                      </Text>
                      <Text>
                        <Badge>{event.resource}</Badge>
                      </Text>
                      <Text>{getNiceDate(event.timestamp * 1)}</Text>
                      <Link url={`/${linksForResource[event.resource]}/${event.resource_id}`}>Link</Link>
                    </InlineStack>
                  </Box>
                );
              })}
          </Card>
        </Layout.Section>
        <Layout.Section variant="oneHalf"></Layout.Section>
      </Layout>
    </BlockStack>
  );
}
